<script setup lang="ts">
import { ref, watch } from 'vue';

import { useMainMenuStateRef } from '#public_ts/composables';

import SideNav from '../side-nav.vue';


const ROOT = __ROOT__;
const { isMountedAndCompact: haveSidenav, isFattapp2Active } = useMainMenuStateRef();
const sideNavOpen = ref(false);

watch(haveSidenav, (val) => {
    if(!val) sideNavOpen.value = false;
}, { flush: 'sync' });

</script>
<template>
    <Teleport v-if="haveSidenav" to="#sidenav-mount">
        <a
            href="#"
            class="sidenav-trigger"
            @click.prevent.stop="sideNavOpen = true"
        >
            <img :src="`${ROOT}images/icons/${isFattapp2Active ? 'toolbar2' : 'toolbar'}.png`" alt="">
        </a>
    </Teleport>
    <SideNav
        v-if="haveSidenav"
        v-model="sideNavOpen"
        side="right"
        title="Seleziona"
        side-nav-class="sidebar-navbar-collapse"
    >
        <div @click="sideNavOpen = false">
            <slot />
        </div>
    </SideNav>
</template>
